import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "inove_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[70]"
          data-testid="cookie-consent"
        >
          <div className="bg-[#1a1a1a]/95 backdrop-blur-xl border border-white/[0.08] rounded-3xl p-6 glow-white">
            <div className="flex items-center gap-2 mb-3 text-[#f5f5f7]">
              <Cookie size={18} />
              <span className="text-sm font-medium">Cookies</span>
            </div>
            <p className="text-[13px] leading-relaxed text-[#86868b] mb-5">
              Usamos cookies para melhorar sua experiência de navegação. Ao
              continuar, você concorda com nossa{" "}
              <Link to="/politica-de-cookies" className="text-[#f5f5f7] underline underline-offset-2">
                Política de Cookies
              </Link>
              .
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept"
                className="flex-1 rounded-full bg-[#f5f5f7] text-[#050505] py-2.5 text-[13px] font-medium hover:bg-white transition-colors"
              >
                Aceitar
              </button>
              <button
                onClick={() => decide("rejected")}
                data-testid="cookie-reject"
                className="flex-1 rounded-full border border-white/15 text-[#f5f5f7] py-2.5 text-[13px] hover:bg-white/5 transition-colors"
              >
                Rejeitar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
